import type { ApiErrorMessage } from './apiErrorMessage';
import { toDiagnosticApiErrorMessage } from './apiErrorMessage';
/**
 * What to report for a failure in an analytics event: a descriptor's `apiError.*` id, since
 * localized copy does not aggregate. Never put it in an event name.
 */
const toAnalyticsErrorMessage = (message: ApiErrorMessage | null | undefined): string =>
  message ? toDiagnosticApiErrorMessage(message) : '';

export default toAnalyticsErrorMessage;
